var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"background pa-1 rounded-lg"},[_vm._v("\n  "+_vm._s("{")+"\n  "),_c('JSONBlock',{attrs:{"item":_vm.json,"level":1}}),_vm._v("\n  "+_vm._s("}")+"\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }